import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-ctvetdashboard',
  templateUrl: './ctvetdashboard.component.html',
  styleUrls: ['./ctvetdashboard.component.css']
})
export class CtvetdashboardComponent {

  public loading = false;


  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

    constructor(private breakpointObserver: BreakpointObserver){
    }

  user = {
    memberSince: new Date('2024-09'),
    avatarUrl: '/assets/img/ctvetlogo.png'
  };

  menuItems = [
    { name: 'Attendance', icon: 'manage_accounts', route: '/ctvet-attendance'  },
    { name: 'Register', icon: 'verified', route: '/register-ctvet-student' },
    { name: 'Roll Call', icon: 'add_task', route: '/roll-call' },
    { name: 'Facials', icon: 'supervised_user_circle', route: '/ctvet-facials' },
    { name: 'Dates', icon: 'event' },
    { name: 'Stats', icon: 'bar_chart' }
  ];

  navItems = [
    { name: 'Feed', icon: 'rss_feed' },
    { name: 'Stats', icon: 'bar_chart' },
    { name: 'More', icon: 'more_horiz' }
  ];
}
